import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store.js'
import acl from './plugins/acl'
import subscriptionMiddleware from './middlewares/SubscriptionMiddleware'

Vue.use(Router)

const router = new Router({

  mode: 'history',

  base: process.env.BASE_URL,

  routes: [

    {
      path: '/criarconta',
      name: 'criarconta',
      meta: { layout: 'AuthLayout', auth: 'guest' },
      component: () => import('./views/RegisterNewUser.vue')
    },

    {
      path: '/login',
      name: 'login',
      meta: { layout: 'AuthLayout', auth: 'guest' },
      component: () => import('./views/Login.vue')
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/Dashboard.vue')
    },

    {
      path: '/',
      name: 'home',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/Home.vue')
    },

    {
      path: '/pessoas',
      name: 'person',
      meta: { layout: 'AppLayout', permission: 'personIndex' },
      component: () => import('./views/Person.vue')
    },
    {
      path: '/pessoas/relatorio',
      name: 'personReport',
      meta: { layout: 'PrintLayout', permission: 'personIndex' },
      component: () => import('./views/Person/PersonReport.vue')
    },

    {
      path: '/pessoas/importar',
      name: 'personsImport',
      meta: { layout: 'AppLayout', permission: 'personCreateEdit' },
      component: () => import('./views/Person/PersonImport.vue')
    },

    {
      path: '/produtos',
      name: 'product',
      meta: { layout: 'AppLayout', permission: 'productIndex' },
      component: () => import('./views/Product.vue'),
      // beforeEnter: (to, from, next) => {

      //   if (store.getters.userPermissionProductIndex) {
      //     next();
      //   } else {
      //     next('/');
      //   }
      // }
    },

    {
      path: '/produtos/importar',
      name: 'productsImport',
      meta: { layout: 'AppLayout', permission: 'productCreateEdit' },
      component: () => import('./views/Product/ProductImport.vue')
    },
    {
      path: '/produtos/relatorio',
      name: 'productReport',
      meta: { layout: 'PrintLayout' },
      component: () => import('./views/Product/ProductReport.vue')
    },

    {
      path: '/vendas',
      name: 'order',
      meta: { layout: 'AppLayout', permission: 'orderIndex' },
      component: () => import('./views/order/Order.vue')
    },

    {
      path: '/pdv',
      name: 'pdv',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/pdv/Pdv.vue')
    },

    {
      path: '/teste_pdv',
      name: 'pdv',
      meta: { layout: 'PdvLayout' },
      component: () => import('./views/pdv/Pdv.vue')
    },

    {
      path: '/vendas/venda/novo',
      name: 'neworder',
      meta: { layout: 'AppLayout', permission: 'orderCreateEdit' },
      component: () => import('./views/order/OrderStore.vue')
    },

    {
      path: '/vendas/venda/editar/:id',
      name: 'editOrder',
      meta: { layout: 'AppLayout', permission: 'orderCreateEdit' },
      component: () => import('./views/order/OrderStore.vue')
    },

    {
      path: '/vendas/devolucao/novo',
      name: 'newReturnig',
      meta: { layout: 'AppLayout', permission: 'orderCreateEdit' },
      component: () => import('./views/order/ReturningStore.vue')
    },
    {
      path: '/vendas/devolucao/editar/:id',
      name: 'editReturnig',
      meta: { layout: 'AppLayout', permission: 'orderCreateEdit' },
      component: () => import('./views/order/ReturningStore.vue')
    },

    {
      path: '/vendas/imprimir/cupom/:id',
      name: 'imprimirCupom',
      meta: { layout: 'PrintLayout', permission: 'orderIndex' },
      component: () => import('./views/order/OrderPrintThermal.vue')
    },

    {
      path: '/vendas/imprimir/nota/:id',
      name: 'imprimirNota',
      meta: { layout: 'PrintLayout', permission: 'orderIndex' },
      component: () => import('./views/order/OrderPrint.vue')
    },

    {
      path: '/vendas/relatorio',
      name: 'relatorio',
      meta: { layout: 'PrintLayout', permission: 'orderIndex' },
      component: () => import('./views/order/OrderReport.vue')
    },

    {
      path: '/nf-e',
      name: 'invoice',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/invoicenfce/Invoice.vue')
    },

    {
      path: '/nfe/relatorio',
      name: 'invoicereport',
      meta: { layout: 'PrintLayout' },
      component: () => import('./views/invoicenfce/InvoiceReport.vue')
    },
    {
      path: '/nfe/novo/:state',
      name: 'newinvoice',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/invoicenfce/InvoiceStore.vue')
    },

    {
      path: '/nfe/editar/:id',
      name: 'editNfe',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/invoicenfce/InvoiceStore.vue')
    },
    {
      path: '/compras',
      name: 'purchase',

      meta: { layout: 'AppLayout', permission: 'purchaseIndex' },
      component: () => import('./views/purchase/Purchase.vue')
    },
    {
      path: '/compras/novo2',
      name: 'insertPurchase',
      meta: { layout: 'AppLayout', permission: 'purchaseCreateEdit' },
      component: () => import('./views/purchase/StorePurchase.vue')
    },
    {
      path: '/compras/novo',
      name: 'insertPurchase',
      meta: { layout: 'AppLayout', permission: 'purchaseCreateEdit' },
      component: () => import('./views/purchase/StorePurchaseForm.vue')
    },
    {
      path: '/compras/editar/:id',
      name: 'editPurchase',
      meta: { layout: 'AppLayout', permission: 'purchaseCreateEdit' },
      component: () => import('./views/purchase/StorePurchaseForm.vue')
    },
    {
      path: '/compras/relatorio',
      name: 'purchaseReport',
      meta: { layout: 'PrintLayout', permission: 'purchaseIndex' },
      component: () => import('./views/purchase/PurchaseReport')
    },
    {
      path: '/empresas',
      name: 'company',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/Company.vue')
    },

    {
      path: '/caixas',
      name: 'account',
      meta: { layout: 'AppLayout', permission: 'accountTransactionIndex' },
      component: () => import('./views/account/Account.vue')
    },

    {
      path: '/fluxodecaixa',
      name: 'cashFlow',
      meta: { layout: 'AppLayout', permission: 'accountTransactionIndex' },
      component: () => import('./views/account/CashFlow.vue')
    },

    {
      path: '/caixas/gerenciar',
      name: 'accountmanager',
      meta: { layout: 'AppLayout', permission: 'accountTransactionIndex' },
      component: () => import('./views/account/AccountManager.vue'),
    },
    {
      path: '/caixas/:account/relatorio/:id/:shift_id',
      name: 'relatorio',
      meta: { layout: 'PrintLayout', permission: 'accountTransactionIndex' },
      component: () => import('./views/account/DrawerReport'),
    },

    {
      path: '/contasareceber',
      name: 'billreceiveble',
      meta: { layout: 'AppLayout', permission: 'billReceiveIndex' },
      component: () => import('./views/BillReceiveble.vue')
    },

    {
      path: '/contasareceber/importar',
      name: 'billreceiveble_import',
      meta: { layout: 'AppLayout', permission: 'billReceiveCreateEdit' },
      component: () => import('./views/BillReceiveble/BillReceivebleImport.vue')
    },

    {
      path: '/contasareceber/imprimir-recibo/:id',
      name: 'imprimir-recibo',
      meta: { layout: 'PrintLayout' },
      component: () => import('./views/BillReceiveblePrint.vue')
    },

    {
      path: '/contasareceber/imprimir-recibo-parcial/:id',
      name: 'imprimir-recibo-parcial',
      meta: { layout: 'PrintLayout' },
      component: () => import('./views/BillReceiveble/BillReceivablePartialPrint.vue')
    },

    {
      path: '/contasareceber/imprimir-promissoria/:id',
      name: 'imprimir-promissoria',
      meta: { layout: 'PrintLayout' },
      component: () => import('./views/BillPromissoryPrint.vue')
    },
    {
      path: '/contasareceber/relatorio',
      name: 'BillReceivebleReport',
      meta: { layout: 'PrintLayout' },
      component: () => import('./views/BillReceiveble/BillReceivebleReport.vue')
    },
    {
      path: '/contasareceber/extrato-debito',
      name: 'BillReceivebleReport',
      meta: { layout: 'PrintLayout' },
      component: () => import('./views/BillReceiveble/DebitStatementPrint.vue')
    },

    {
      path: '/contasapagar',
      name: 'billpayable',
      meta: { layout: 'AppLayout', permission: 'billPaymentIndex' },
      component: () => import('./views/BillPayable.vue')
    },



    {
      path: '/contasapagar/relatorio',
      name: 'billpayableReport',
      meta: { layout: 'PrintLayout', permission: 'billPaymentIndex' },
      component: () => import('./views/billpayable/BillPayableReport.vue')
    },

    {
      path: '/contasapagar/importar',
      name: 'billPayableImport',
      meta: { layout: 'AppLayout', permission: 'billPaymentCreateEdit' },
      component: () => import('./views/billpayable/BillPayableImport.vue')
    },

    {
      path: '/estoque',
      name: 'stock',
      meta: { layout: 'AppLayout', permission: 'stockTransactionIndex' },
      component: () => import('./views/Stock.vue'),
    },
    {
      path: '/estoque/inventario',
      name: 'StockAudit',
      meta: { layout: 'PrintLayout', permission: 'stockTransactionIndex' },
      component: () => import('./views/Product/StockAuditIndex'),
    },

    // {
    //     path: '/importar/xml',
    //     name: 'inputstockxml',
    //     meta: { layout: 'AppLayout' },
    //     component: () => import('./views/stock/InputStockXml.vue'),
    // },

    {
      path: '/usuarios',
      name: 'user',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/User.vue'),
    },
    {
      path: '/categorias',
      name: 'category',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/Category/Category.vue'),
    },
    {
      path: '/assinar',
      name: 'subscribe',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/subscription/Subscribe.vue'),
    },
    {
      path: '/comissao',
      name: 'commission',
      meta: { layout: 'AppLayout', permission: 'admin' },
      component: () => import('./views/Commission/Commission.vue'),
    },
    {
      path: '/vendas/relatorio/venda-de-produtos-por-vendedor',
      name: 'ReportOrderOfProductsBySalesman',
      meta: { layout: 'PrintLayout', permission: 'admin' },
      component: () => import('./views/order/ReportOrderOfProductsBySalesman.vue'),
    },
    {
      path: '/notificacoes',
      name: 'notification',
      meta: { layout: 'AppLayout' },
      component: () => import('./views/notifications/index.vue'),
    },
    {
      path: '/produtos/etiquetas',
      name: 'tags',
      meta: { layout: 'AppLayout', permission: 'productIndex' },
      component: () => import('./views/Product/ProductTagIndex.vue'),
    },
    {
      path: '/produtos/etiquetas/imprimir',
      name: 'printTagsIndex',
      meta: { layout: 'PrintLayout', permission: 'productIndex' },
      component: () => import('./views/Product/PrintTagsIndex.vue'),
    },

    {
      path: '/fluxodecaixa/planodecontas',
      name: 'planAccountsManager',
      meta: { layout: 'AppLayout', permission: 'accountTransactionIndex' },
      component: () => import('./views/account/AccountPlanManager.vue'),
    },
    {
      path: "/assinatura-expirada",
      name: 'subscriptionExpired',
      meta: { layout: 'AuthLayout', subscriptionPage: true },
      component: () => import('./views/subscription/SubscriptionExpired.vue'),
    },
    {
      path: "/not-authorized",
      name: "401",
      meta: { layout: 'AppLayout' },
      component: () => import('./views/401.vue'),
    },
    {
      path: "*",
      name: "404",
      meta: { layout: 'AppLayout' },
      component: () => import('./views/404.vue'),
    }
  ],
})

router.beforeEach(async (to, from, next) => {

  store.commit('app/setLastRoute', from)

  if (to.meta.auth !== 'guest') {

    if (!store.getters['auth/isLoggedIn']) {
      await store.dispatch('auth/loadUser')
    }

    if (!store.getters['auth/isLoggedIn']) {
      next('/login');
    }

    if (to.meta.permission) {
      if (!acl.can(to.meta.permission)) {
        next('/not-authorized');
      }
    }

    if (!to.meta.subscriptionPage) {
      subscriptionMiddleware(to, from, next)
    }

  }


  store.commit('pageChanged', { page: to.name })

  next();

});

export default router
